import { Car, Landmark, BadgeCheck } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal, Kicker } from "@/components/Reveal";

const icons = [Car, Landmark, BadgeCheck];

const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" className="relative py-24 sm:py-32 bg-ink/40 scroll-mt-20" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <Reveal className="max-w-2xl">
          <Kicker>{t.services.kicker}</Kicker>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-slate-50">
            {t.services.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-6 lg:gap-8">
          {t.services.items.map((s, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={s.title} delay={i * 0.12}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group relative h-full glass-card rounded-2xl border border-gold/15 p-8 lg:p-10 hover:-translate-y-2 hover:border-gold/50 hover:shadow-[0_24px_60px_rgba(0,0,0,0.5)] transition-all duration-500"
                >
                  <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-gold/10 ring-1 ring-gold/30 group-hover:bg-gold/20 transition-colors">
                    <Icon size={26} className="text-gold" />
                  </div>
                  <h3 className="mt-6 font-display text-xl sm:text-2xl text-slate-100">{s.title}</h3>
                  <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed">{s.desc}</p>
                  <span className="absolute top-6 right-8 font-mono text-xs text-gold/40">0{i + 1}</span>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
